
<panel-block id="pn-required" panel-group>
  <panel-item>
    <label :for="model.idForProp('aggregate_type')">Choose an Aggregate Function</label>
    <a-select
      :id="model.idForProp('aggregate_type')"
      :options="aggregateOptions"
      compress
      v-model="model.aggregate_type"
      @input="$emit('input')"
    ></a-select>
  </panel-item>
</panel-block>
